import ViewIcon from '../../../assets/icons/view.svg?react';
import EditIcon from '../../../assets/icons/edit.svg?react';
import CopyIcon from '../../../assets/icons/copy.svg?react';
import Tooltip from '../../common/tooltip.tsx';
import { Link } from 'react-router-dom';
import { useCopyQuestion } from '../questions-hooks.tsx';
import { useGetMe } from '../../../utils/hooks.ts';

interface IIdTableComponent {
  id: number;
  displayValue: number;
  onPreview: () => void;
}
const QuestionIdTableComponent = ({
  id,
  displayValue,
  onPreview,
}: IIdTableComponent) => {
  const { isAdmin, isVA } = useGetMe();

  const { openCopyModal, CopyModal } = useCopyQuestion(id, displayValue);

  const isHasPermissionsForEditQuestion = isAdmin || isVA;
  const isHasPermissionsForDuplicateQuestion = isAdmin || isVA;

  return (
    <div className={'flex w-36 items-center justify-between'}>
      <span>{displayValue}</span>
      <div className={'flex'}>
        <Tooltip tip={'Preview'}>
          <span
            className={'cursor-pointer p-1'}
            onClick={onPreview}
          >
            <ViewIcon />
          </span>
        </Tooltip>

        {isHasPermissionsForEditQuestion && (
          <Tooltip tip={'Edit'}>
            <Link to={`/edit-question/${id}`} className={'cursor-pointer p-1'}>
              <EditIcon />
            </Link>
          </Tooltip>
        )}

        {isHasPermissionsForDuplicateQuestion && (
          <Tooltip tip={'Duplicate'}>
            <span className={'cursor-pointer p-1'} onClick={openCopyModal}>
              <CopyIcon />
            </span>
          </Tooltip>
        )}
      </div>

      <CopyModal />
    </div>
  );
};
export default QuestionIdTableComponent;
